import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { MatrixChannel, MatrixChannelViewData } from 'icreate/common/models/matrix-channel';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MatrixChannelService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByElementId(elementId: string) {
        return await lastValueFrom(
            this.http.get<MatrixChannelViewData[]>(`${this.domain}/api/matrixChannel`, {
                headers: this.headers,
                params: { elementId },
            })
        );
    }

    async create(matrixChannelData: MatrixChannel[]) {
        return await lastValueFrom(
            this.http.post<MatrixChannelViewData>(`${this.domain}/api/matrixChannel`, matrixChannelData, {
                headers: this.headers,
            })
        );
    }

    async update(matrixChannelData: MatrixChannel[], elementId: string) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/matrixChannel`, matrixChannelData, {
                headers: this.headers,
                params: { elementId },
            })
        );
    }

    async deleteByElementId(elementId: string) {
        return await lastValueFrom(
            this.http.delete(`${this.domain}/api/matrixChannel`, {
                headers: this.headers,
                params: { elementId },
            })
        );
    }
}
